import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeMotivationPopupState } from '../../../actions/favorite';
import { openLoginPopupAction, openRegistrationPopupAction } from '../../../actions/header';
import { selectIsMotivationPopupVisible } from '../../../selectors/favorite';
import { TThunkDispatch } from '../../../types/redux';

interface IMotivationPopup {
  isVisible: boolean;
  handleClose(): void;
  handleLogin(): void;
  handleRegister(): void;
}

export const useMotivationPopup = (): IMotivationPopup => {
  const isVisible = useSelector(selectIsMotivationPopupVisible);
  const dispatch: TThunkDispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(changeMotivationPopupState(false));
  }, [dispatch]);

  const handleRegister = React.useCallback(() => {
    dispatch(changeMotivationPopupState(false));
    dispatch(openRegistrationPopupAction());
  }, [dispatch]);

  const handleLogin = React.useCallback(() => {
    dispatch(changeMotivationPopupState(false));
    dispatch(openLoginPopupAction());
  }, [dispatch]);

  return {
    isVisible,
    handleClose,
    handleLogin,
    handleRegister,
  };
};
